import React from 'react';
import { cx } from './utils';

const Input = React.forwardRef(
  (
    {
      label,
      hint,
      error,
      className = '',
      inputClassName = '',
      icon,
      compact = false,
      ...props
    },
    ref
  ) => {
    const hasLabel = Boolean(label);
    return (
      <label className={cx('block', className)}>
        {hasLabel && (
          <span
            className={cx(
              'font-semibold uppercase tracking-[0.24em] text-slate-400',
              compact ? 'text-[9px]' : 'text-[10px]'
            )}
          >
            {label}
          </span>
        )}
        <div className={cx('relative', compact ? 'mt-1' : hasLabel ? 'mt-2' : 'mt-0')}>
        {icon ? <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">{icon}</span> : null}
        <input
          ref={ref}
          className={cx(
            'w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm text-slate-800 placeholder:text-slate-400 focus:border-[#B88A5B] focus:outline-none focus:ring-2 focus:ring-[#F4EADF]',
            icon ? 'pl-9' : '',
            inputClassName
          )}
          {...props}
        />
        </div>
        {hint && !error && <span className="mt-1 block text-xs text-slate-500">{hint}</span>}
        {error && <span className="mt-1 block text-xs text-red-600">{error}</span>}
      </label>
    );
  }
);

Input.displayName = 'Input';

export default Input;
